import PageHandler from "./PageHandler";
import Pages from "Pages";

class OfflineLicensesInUseDetailPageHandler extends PageHandler {
  constructor() {
    super(
      "offline-licenses-in-use-detail",
      Pages.OfflineLicensesInUseDetailPage
    );
  }

  fetch() {
    this.rootStore.data.ApplicationsStore.fetch();
  }
}

export default OfflineLicensesInUseDetailPageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/OfflineLicensesInUseDetailPageHandler.js